// extracted by mini-css-extract-plugin
export var container = "lcChildLinksBlocks-module--container--5703e";
export var link = "lcChildLinksBlocks-module--link--6b5c9";